/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Link, Flex, Image, useMultiStyleConfig} from '@chakra-ui/react'

const SocialIcons = ({icons}) => {
    const styles = useMultiStyleConfig('Footer')

    return (
        <Flex {...styles.socialIcons}>
            {icons?.length > 0 &&
                icons.map(({icon, link}) => (
                    <Link key={link?.title} href={link?.href} isExternal>
                        <Image
                            loading="lazy"
                            {...styles.socials}
                            src={icon?.url}
                            alt={link?.title}
                        />
                    </Link>
                ))}
        </Flex>
    )
}

SocialIcons.displayName = 'SocialIcons'

SocialIcons.propTypes = {
    icons: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string}),
            link: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
        }),
    ),
}

export default SocialIcons
